<template>
<div class="con18">
    <div class="bhopdong2">
        <p style="text-align:center !important"><a href="https://drive.google.com/file/d/1LjkCZLSrlKppTj8K-UHweI7mCNBUnphz/view" style="color:#2980b9; font-weight:bold" target="_blank">C&Ocirc;NG VĂN GỬI ỦY BAN NH&Acirc;N D&Acirc;N TH&Agrave;NH PHỐ Đ&Agrave; NẴNG</a></p>

        <div class="hd5"><img alt="" src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=17571397462105ulnF" /></div>

        <!-- <div class="hd5"><iframe frameborder="0" scrolling="no" src="https://drive.google.com/file/d/1ra7yEr5lDoroxE67BK60M4OSjDluGlCL/preview" style="width:100%;border:0;"></iframe></div> -->
<div class="hd5 p-5 bd-tl">
<p dir="ltr"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76">T&Agrave;I LIỆU THAM KHẢO</b></p>
<ol>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi">1. C&ocirc;ng ty cổ phần dịch vụ nền di động Việt Nam</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/chuongtrinhtaitroxathidiem">2. Chương tr&igrave;nh t&agrave;i trợ x&atilde; th&iacute; điểm</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/giaoduc#chuongtrinhtaitro">3. Chương tr&igrave;nh t&agrave;i trợ trường học</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/chuongtrinhtaitroxathidiem#danang/hethongcnttdanang">4. Hệ thống c&ocirc;ng nghệ th&ocirc;ng tin 15 x&atilde; tại Đ&agrave; Nẵng</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/chi-tiet.html/1754996619254pg5cM">5. Quyết định th&agrave;nh lập nh&oacute;m tư vấn x&atilde; th&iacute; điểm</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://drive.google.com/file/d/1SILrA9ayeH-bQuCsbfTmbV8vMGC37HSC/view">6. Quyết định ph&acirc;n c&ocirc;ng nh&oacute;m triển khai trường học v&agrave; x&atilde;, phường th&iacute; điểm</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/chuongtrinhtaitroxathidiem#danang/xadailoc">7. Thỏa thuận t&agrave;i trợ x&atilde; Đại Lộc</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/chuongtrinhtaitroxathidiem#danang/xaphuthuan">8. Thỏa thuận t&agrave;i trợ x&atilde; Ph&uacute; Thuận</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/chuongtrinhtaitroxathidiem#danang/xavugia">9. Thỏa thuận t&agrave;i trợ x&atilde; Vu Gia</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/chuongtrinhtaitroxathidiem#danang/xahanha">10. Thỏa thuận t&agrave;i trợ x&atilde; H&agrave; Nha</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/chuongtrinhtaitroxathidiem#danang/xathuongduc">11. Thỏa thuận t&agrave;i trợ x&atilde; Thượng Đức</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/chuongtrinhtaitroxathidiem#danang/xadienbantay">12. Thỏa thuận t&agrave;i trợ x&atilde; Điện B&agrave;n T&acirc;y</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/chuongtrinhtaitroxathidiem#danang/xagonoi">13. Thỏa thuận t&agrave;i trợ x&atilde; G&ograve; Nổi</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/chuongtrinhtaitroxathidiem#danang/xabanna">14. Thỏa thuận t&agrave;i trợ x&atilde; B&agrave; N&agrave;</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/chuongtrinhtaitroxathidiem#danang/xahoavang">15. Thỏa thuận t&agrave;i trợ x&atilde; H&ograve;a Vang</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/chuongtrinhtaitroxathidiem#danang/xahoatien">16. Thỏa thuận t&agrave;i trợ x&atilde; H&ograve;a Tiến</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/chuongtrinhtaitroxathidiem#danang/xathubon">17. Thỏa thuận t&agrave;i trợ x&atilde; Thu Bồn</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/chuongtrinhtaitroxathidiem#danang/xaduyxuyen">18. Thỏa thuận t&agrave;i trợ x&atilde; Duy Xuy&ecirc;n</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/chuongtrinhtaitroxathidiem#danang/xanamphuoc">19. Thỏa thuận t&agrave;i trợ x&atilde; Nam Phước</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/chuongtrinhtaitroxathidiem#danang/xaxuanphu">20. Thỏa thuận t&agrave;i trợ x&atilde; Xu&acirc;n Ph&uacute;</a></b></p>
	</li>
	<li aria-level="1" dir="ltr">
	<p dir="ltr" role="presentation"><b id="docs-internal-guid-b085c7e4-7fff-8e8a-0e27-eea27d07fc76"><a href="https://vimass.vn/vi/chuongtrinhtaitroxathidiem#danang/xaduynghia">21. Thỏa thuận t&agrave;i trợ x&atilde; Duy Nghĩa</a></b></p>
	</li>
</ol>
    <img style="width: 250px;" alt="" src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1757575240238mNP6F" />
<div class=""></div>
</div>


    </div>

    <div class="imachudv"><img alt="" src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1757140010878t5OhF" /></div>
</div>
</template>

<script>
import axios from "axios";
import {
    apiChiTietBaiViet
} from "@/components/listService";
export default {
    name: "TestQuiz",
    data() {
        return {
            lang: "",
            showModal: false,
            currentSlide: 0,
            items: [],
            apiUrl: "",
            base64: "",
            base64Title: "",
            //title
            titleHeThong: "",
            //content
            contentHeThong: "",
        };
    },
    mounted() {
        this.fetchData();
        if (window.innerWidth <= 768) {
            this.isMenuVisible = false;
        } else {
            this.isMenuVisible = true;
        }

        const lang = localStorage.getItem("languages") || "vi";

        this.lang = lang;
    },
    computed: {
        slides() {
            if (this.items.length === 0) {
                return []; // Return an empty array if items is empty
            } else {
                return this.items
                    .filter((item) => item.id !== undefined)
                    .map((item) => ({
                        src: item.src,
                        caption: item.caption,
                        lang: item.lang,
                        srcChiTiet: item.srcChiTiet
                            .split(";")
                            .filter((url) => url.trim() !== ""),
                        capChiTiet: item.capChiTiet
                            .split(";")
                            .filter((cap) => cap.trim() !== ""),
                    }));
            }
        },
    },
    methods: {
        async fetchData() {
            this.apiUrl =
                "https://sheets.googleapis.com/v4/spreadsheets/1zsSXFf0MMRfyJU3iDr70Te8OjvtkI6M9dFbOnWRwDXw/values/json?key=AIzaSyB6KdsUEG02YYtkYDjFlVA-HrSvs_PULh4";

            try {
                const response = await axios.get(this.apiUrl);
                const lang = localStorage.getItem("languages") || "vi";
                this.items = response.data.values
                    .map((row) => {
                        if (row[2] && lang && row[2].trim() === lang.trim()) {
                            return {
                                id: row[4],
                                src: row[0],
                                caption: row[1],
                                // srcChiTiet: row[2],
                                // capChiTiet: row[3],
                            };
                        }
                    })
                    .filter((item) => item !== undefined);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        },
        async performPostRequest(id) {
            this.lang = localStorage.getItem("languages") || "vi";

            try {
                // Thực hiện POST request
                const response = await axios.post(apiChiTietBaiViet, {
                    id: id,
                    langId: "0",
                });
                if (this.lang === "vi") {
                    this.base64 = response.data.result.content_vi;
                    this.base64Title = response.data.result.title_vi;
                } else if (this.lang === "en") {
                    this.base64 = response.data.result.content_en;
                    this.base64Title = response.data.result.title_en;
                } else if (this.lang === "cn") {
                    this.base64 = response.data.result.content_cn;
                    this.base64Title = response.data.result.title_cn;
                } else if (this.lang === "kr") {
                    this.base64 = response.data.result.content_kr;
                    this.base64Title = response.data.result.title_kr;
                } else {
                    this.base64 = response.data.result.content_vi;
                    this.base64Title = response.data.result.title_vi;
                }
                var title = atob(this.base64Title);
                var decodedString = atob(this.base64);

                this.titleHeThong = decodeURIComponent(escape(title));
                this.contentHeThong = decodeURIComponent(escape(decodedString));
            } catch (error) {
                console.error("Error:", error);
            }
        },
        openModal(index, id) {
            this.performPostRequest(id);
            this.currentSlide = index;
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
        prevSlide() {
            this.currentSlide =
                (this.currentSlide - 1 + this.slides.length) % this.slides.length;
        },
        nextSlide() {
            this.currentSlide = (this.currentSlide + 1) % this.slides.length;
        },
    },
};
</script>

<style scoped>
ol{
  font-size: 14px;
}
ol li{
width: 55%;margin: auto; display: flex; }

.bd-tl {
    border: 5px solid #e5e5e5
}
.con18 {
    font-size: 18px
}

.imachudv {
    width: 100%;
    float: left;
    text-align: center;
    margin: 20px 0;
}

.imachudv img {
    max-width: 100%;
    margin: 10px auto;
}

iframe {
    width: 100%;
    float: left;
    max-width: 790px;
    min-height: 1117px
}

.title-bai-viet {
    DISPLAY: NONE;
}

.bhopdong2 {
    width: 98%;
    text-align: center;
    float: left;
    margin: 10px 1%;
}

.hd5 {
    width: 48%;
    margin: 1%;
    float: left;
    text-align: center;
    margin: 5px 1%;
}

.hd5 img {
    max-width: 800px;
    width: 100%;
    border: 5px solid #e5e5e5;
}

.hd5 p {
    text-align: center !important
}

.hd3 {
    width: 30%;
    margin: 1%;
    float: left;
    text-align: center
}

.hd3 img {
    max-width: 600px;
    width: 100%;
    border: 5px solid #e5e5e5;
}

.hd3 p {
    text-align: center !important
}


@media (max-width: 800px) {
    .hd3 {
        width: 100%;
        float: left;
    }

    .hd5 {
        width: 100%;
        float: left;
    }

    iframe {
        min-height: 400px
    }
    ol li{
width: 100%;margin: auto; display: flex; }
}
</style>
